import { HeadingProps } from "../../Types/CommonElementType";

const H1:React.FC<HeadingProps> = (props) => {
  return (
    <h1 {...props} style={props.style}>
      {props.children}
    </h1>
  );
};

export default H1;
